import React from 'react'

import facebook_cover from '../images/dieet-club-facebook-cover.jpg';
import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';
import facebook_ads from '../images/facebook-ads-dieet-club.png';
import facebook_posts from '../images/facebook-berichten-creatief.png';
import facebook_followers from '../images/facebook-volgers-dieet-club-1200.png';
import img from '../images/inflow-marketingbureau.avif';


export default class extends React.Component {

  render() {
    document.title = "Case Study Dieet.Club - Peter van der Meer - Helpt jouw bedrijf groeien.";
    return (
      <div>

        <div className="full blue" style={{paddingTop:"8em", paddingBottom:"8em"}}>

          <div className="wrap">
            <div className="col-2" style={{textAlign:"center"}}>
              <div>
                <img src={facebook_cover} alt="INFLOW Online Marketing | Case Study Dieet.Club" style={{maxWidth:"100%", marginTop:"5em", borderRadius:"7px"}} />
              </div>
            </div>
            <div className="col-2" style={{padding:"3%"}}>
              <h2 className="logo-text" style={{marginBottom:".3em"}}>INFLOW Online Marketing <span style={{opacity:".7"}}>case study</span></h2>
              <h1 className="header-responsive4" style={{fontFamily:"Times New Roman, Times, serif", marginTop:"0", marginBottom:".3em"}}>Hoe Dieet.Club een Cost-Per-Click bereikte van €0,14 met Facebook Marketing.</h1>
              <h2 style={{fontSize:"1.1em", opacity:".7", margin:"1em 0 4.3em"}}>Doel: Testen van nieuwe app, is er interesse voor een afslank-app?</h2>
              <div style={{marginBottom:"5em"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-fat btn-if btn-if-fill-red">Neem contact op</a><a href="https://www.linkedin.com/in/peterdotplus/" target="blank"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #fff", width:"90px"}} /></a></div>
            </div>
          </div>

        </div>

        <div className="full">
          <div className="wrap content-block">
            <h2>Resultaten</h2>
            <div className="col-2">
              <ul style={{fontSize:"250%"}}>
                <li style={{lineHeight:"1", marginBottom:"1em"}}>Goedkope websitebezoeken met een Cost-Per-Click van €0,14 (4,5x goedkoper dan Nederlands gemiddelde)</li>
                <li style={{lineHeight:"1", marginBottom:"1em"}}>Gevonden doelgroep: vrouwen tussen de 25 en 34 jaar, en 55+</li>
                <li style={{lineHeight:"1", marginBottom:"1em"}}>Creatieve advertenties die veel website-kliks opleverden</li>
                <li style={{lineHeight:"1", marginBottom:"1em"}}>688 klikken op links voor slechts €148,49</li>
                <li style={{lineHeight:"1", marginBottom:"1em"}}>19 nieuwe aanmeldingen op de webapplicatie</li>
              </ul>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <img src={facebook_ads} alt="inflow.polymedia.nl | voordelen Online Marketing inflow" style={{maxWidth:"85%", borderRadius:"7px"}} />
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#E798AB"}}>
          <div className="wrap content-block">
            <div className="col-2" style={{textAlign:"center"}}>
              <img src={facebook_posts} alt="inflow.polymedia.nl | facebook pagina berichten Online Marketing inflow" style={{maxWidth:"85%", borderRadius:"7px"}} />
            </div>
            <div className="col-2">
              <h2 className="header-responsive4" style={{fontWeight:"700", margin:"1.2em 0 .8em", padding:"0 110px",color:"#000"}}>Facebook-pagina gevuld met interessante berichten</h2>
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#E66859"}}>
          <div className="wrap content-block">
            <div className="col-2">
              <h2 className="header-responsive4" style={{fontWeight:"700", margin:"1.2em 0 .8em", padding:"0 110px",color:"#000"}}>Experimenten met verschillende doelgroepen, afbeeldingen, en teksten</h2>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <img src={facebook_ads} alt="inflow.polymedia.nl | facebook advertenties experimenten Online Marketing inflow" style={{maxWidth:"85%", borderRadius:"7px"}} />
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#E798AB"}}>
          <div className="wrap content-block">
            <div className="col-2" style={{textAlign:"center"}}>
              <img src={facebook_followers} alt="inflow.polymedia.nl | facebook pagina volgers Online Marketing inflow" style={{maxWidth:"85%", borderRadius:"7px"}} />
            </div>
            <div className="col-2">
              <h2 className="header-responsive4" style={{fontWeight:"700", margin:"1.2em 0 .8em", padding:"0 110px",color:"#000"}}>Binnen korte tijd 1200+ volgers</h2>
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#E66859"}}>
          <div className="wrap content-block">
            <div className="col-2">
              <h2 className="header-responsive4" style={{fontWeight:"700", margin:"1.2em 0 .8em", padding:"0 110px",color:"#000"}}>688 klikken op links, 19 nieuwe aanmeldingen</h2>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <img src={facebook_ads} alt="inflow.polymedia.nl | facebook advertenties experimenten Online Marketing inflow" style={{maxWidth:"85%", borderRadius:"7px"}} />
            </div>
          </div>
        </div>

        <div className="full blue" style={{paddingTop:"8em", paddingBottom:"8em"}}>

          <div className="wrap">
            <div className="col-2" style={{padding:"3%"}}>
              <h2 className="logo-text" style={{marginBottom:".3em"}}>inflow <span style={{opacity:".7"}}>Online Marketing</span></h2>
              <h1 className="header-responsive" style={{fontFamily:"Times New Roman, Times, serif", marginTop:"0", marginBottom:".3em"}}>Helpt jouw bedrijf groeien.</h1>
              <h2 style={{fontSize:"1.1em", opacity:".7", margin:"1em 0 4.3em"}}>Ik doe transparante marketing met een focus op Facebook en LinkedIn, door middel van creatieve berichten en resultaatgerichte advertenties.</h2>
              <div style={{marginBottom:"5em"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-fat btn-if btn-if-fill-red">Neem contact op</a><a href="https://www.linkedin.com/in/peterdotplus/" target="blank"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #fff", width:"90px"}} /></a></div>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <div style={{position:"relative"}}>
                <img src={img} alt="INFLOW Online Marketing | Welkom!" style={{width:"530px", maxWidth:"70%", borderRadius:"50%"}} />
                <svg style={{position:"absolute", top:"77px", right:"50px"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297.37 297.37"><g><g><path style={{fill:"#0DAA99"}} d="M18.83,33.994c0,0,21.751,329.063,138.691,251.557S278.54,93.824,278.54,93.824l-58.47-48.952C141.204,44.872,36.502,0,36.502,0L18.83,33.994z"/></g></g></svg>
                <svg style={{position:"absolute", bottom:"10px", left:"80px"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368.935 368.935"><g><g><path style={{fill:"#E798AB"}} d="M330.835,0C130.884,155.665,85.659,39.304,85.659,39.304c-113.127,128.764,0,246.284,0,246.284 c199.953-78.446,44.039,83.347,44.039,83.347C372.496,355.46,330.835,0,330.835,0z"/></g></g></svg>
                <svg style={{position:"absolute", left:"22px"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.93 285.93"><g><g><path style={{fill:"#F2AA22"}} d="M131.328,285.93c59.792-29.474,140.447-26.967,140.447-26.967v-55.299 C134.89,89.444,240.952,42.304,240.952,42.304c-255.636-95.184-225.721,0-225.721,0S14.736,216.713,14.41,285.93H131.328z"/></g></g></svg>
              </div>
            </div>
          </div>

        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/CaseStudy-DieetClub.js